import { useMutation } from "@tanstack/react-query";
import { GptResponse, getOpenAiPromptResponse } from "./getOpenAiPromptResponse";

export function useOpenAi() {
    return useMutation({
        mutationFn: (messages: GptResponse) => getOpenAiPromptResponse(messages),
        onSuccess: (data) => {},
    });
}
